export const authRoles = {
  admin: ['Administrator'], // Only ADMIN has access
  others: ['Subscriber', 'Editor', 'Author'], // Only 'SUBSCRIBER', 'EDITOR', 'AUTHOR' has access
};